import { NotificationIndexParams } from '@/models/apis/notification/notificationRequest';
import {
  Notification,
  NotificationFile,
} from '@/models/apis/notification/notificationResponse';
import {
  roundUpToNearest10Minutes,
  dtFormat,
} from '@/lib/dateHelper';

export const nonNullableFields = [
  'title',
  'content',
  'publishStartAt',
];

export const toJaFieldMap = [
  { key: 'publishStartAt', value: '掲載開始日時' },
  { key: 'publishEndAt', value: '掲載終了日時' },
  { key: 'group1Id', value: '対象組織' },
  { key: 'title', value: 'タイトル' },
  { key: 'content', value: '内容' },
];

export interface NotificationInputModel {
  id: number;
  publishStartAt: string;
  publishEndAt: string;
  title: string;
  content: string;
  group1Id: number | null;
  saveFiles: NotificationFile[];
  removeFileIds: number[];
}

export interface NotificationLocalStorage {
  notificationAreaLastClosedAt: string;
}

export const createInitialSearchParams = (): NotificationIndexParams => {
  const now = new Date();
  const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate(), 0, 0, 0, 0);
  const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);

  return {
    search_range_start: oneMonthAgo,
    search_range_end: todayEnd,
    title: '',
  };
};

export const createInitialInputModel = (): NotificationInputModel => {
  return {
    id: 0,
    publishStartAt: roundUpToNearest10Minutes(new Date(), 'yyyy-mm-dd HH:MM'),
    publishEndAt: '',
    title: '',
    group1Id: null,
    content: '',
    saveFiles: [],
    removeFileIds: [],
  };
};

export const convertToDisplayData = (notification: Notification): Notification => {
  const format = 'yyyy/mm/dd HH:MM';
  return {
    ...notification,
    group1Name: notification.group1?.name || '全て',
    publish_start_at: notification.publish_start_at
      ? dtFormat(notification.publish_start_at, format)
      : notification.publish_start_at,
    publish_end_at: notification.publish_end_at
      ? dtFormat(notification.publish_end_at, format)
      : notification.publish_end_at,
    created_at: notification.created_at
      ? dtFormat(notification.created_at, format)
      : notification.created_at,
    updated_at: notification.updated_at
      ? dtFormat(notification.updated_at, format)
      : notification.updated_at,
  };
};

export const convertNotificationToInputModel = (notification: Notification): NotificationInputModel => {
  return {
    id: notification.id,
    publishStartAt: notification.publish_start_at,
    publishEndAt: notification.publish_end_at || '',
    title: notification.title,
    content: notification.content,
    group1Id: notification.group1?.id || null,
    saveFiles: notification.files,
    removeFileIds: [],
  };
};

export function sortNotifications(notifications: Notification[]): Notification[] {
  return notifications.sort((a, b) => {
    // まず掲載開始日時で降順ソート
    const startA = new Date(a.publish_start_at).getTime();
    const startB = new Date(b.publish_start_at).getTime();
    if (startA !== startB) {
      return startB - startA;
    }

    // 掲載開始日時が同じ場合、掲載終了日時で降順ソート (null は最大扱い)
    const endA = a.publish_end_at ? new Date(a.publish_end_at).getTime() : Number.MAX_SAFE_INTEGER;
    const endB = b.publish_end_at ? new Date(b.publish_end_at).getTime() : Number.MAX_SAFE_INTEGER;
    return endB - endA;
  });
}
